<template>
  <div class="enterpriseAndCommonality">
    <el-dialog
      width="960px"
      height="600px"
      title="审批信息"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      show-close
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="评价信息" name="first">
          <div class="AddSupplierA">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="110px"
              class="contactsForm"
            >
              <!-- <div class="AddSupplierATitle">选择评定年份</div> -->
              <el-row style="margin-top: 10px">
                <el-col :span="18">
                  <el-form-item
                    label="选择评定年份："
                    prop="scoreYear"
                    label-width="140px"
                  >
                    <!-- <el-date-picker
                      v-model="ruleForm.scoreYear"
                      type="year"
                      placeholder="选择年"
                    >
                    </el-date-picker> -->
                    <el-select
                      ref="elSelect"
                      v-model="ruleForm.scoreYear"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      @change="changeYear"
                    >
                      <el-option
                        :label="item.label"
                        :value="item.name"
                        v-for="(item, index) in yearList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="AddSupplierATitle">合作单位信息</div>
              <div class="AddSupplierAContent">
                <!-- <esoterica @setIsShowHelpExplain="setIsShowHelpExplain"></esoterica> -->

                <el-row>
                  <el-col :span="22">
                    <!--公司名称-->
                    <el-form-item class="noMarginBottom" label="合作单位名称：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.supplierName"
                        maxlength="60"
                        placeholder="请输入合作单位名称"
                        readonly
                      ></el-input>
                    </el-form-item>

                    <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
                  </el-col>
                  <el-col :span="2">
                    <el-button type="text" @click="openCompanyDetail()"
                      >查看详情></el-button
                    >
                  </el-col>
                </el-row>
                <el-row :span="3">
                  <el-col :span="12">
                    <!--办公电话-->
                    <el-form-item label="办公电话：" class="noMarginBottom">
                      <el-input
                        class="contactsInput"
                        v-model="workPhone"
                        maxlength="20"
                        placeholder="请输入办公电话"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--法人姓名-->
                    <el-form-item class="noMarginBottom" label="负责人：">
                      <el-input
                        class="contactsInput"
                        v-model="legalPerson"
                        maxlength="12"
                        placeholder="请输入负责人"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <!--注册资金-->
                    <el-form-item
                      label="注册资金："
                      class="noMarginBottom"
                      prop="registeredCapital"
                    >
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.registeredCapital"
                        maxlength="20"
                        placeholder="请输入注册资金："
                        :readonly="flag"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--资质等级-->
                    <el-form-item class="noMarginBottom" label="资质等级：">
                      <el-input
                        class="contactsInput"
                        v-model="ruleForm.qualificationLevel"
                        maxlength="12"
                        placeholder="请输入资质等级："
                        :readonly="flag"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="AddSupplierATitle">项目评分</div>
              <div style="margin-top: 10px">
                <el-row>
                  <el-col :span="18">
                    <el-form-item
                      label="评价模板："
                      prop="scoreTemplate"
                      label-width="110px"
                    >
                      <el-select
                        v-model="ruleForm.scoreTemplate"
                        filterable
                        default-first-option
                        placeholder="请选择"
                        :disabled="flag"
                        @change="changeValue"
                      >
                        <el-option
                          label="劳务合作单位评价表"
                          value="劳务合作单位评价表"
                        ></el-option>
                        <el-option
                          label="设备物资合作单位评价表"
                          value="设备物资合作单位评价表"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="AddSupplierAContent">
                <el-table
                  ref="multipleTables"
                  :data="tableData"
                  stripe
                  border
                  size="mini"
                  show-summary
                  :summary-method="getSummaries"
                >
                  <el-table-column
                    prop="indexNum"
                    width="45"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    prop="project"
                    label="评审项目"
                    width="70"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="content"
                    label="评审内容"
                    width="340"
                  ></el-table-column>
                  <el-table-column
                    prop="totalScore"
                    label="分值"
                    width="60"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column label="原因" width="200">
                    <template slot-scope="scope">
                      <el-form-item>
                        <el-input
                          v-model="scope.row.reason"
                          type="textarea"
                          :rows="2"
                          maxlength="100"
                          :readonly="flag"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="扣分" prop="deduct" width="120">
                    <template slot-scope="scope">
                      <el-form-item>
                        <el-input-number
                          v-model="scope.row.deduct"
                          :min="0"
                          :max="scope.row.totalScore"
                          size="mini"
                          :readonly="flag"
                        ></el-input-number>
                        <!-- <el-input
                          v-model="scope.row.deduct"
                          :readonly="flag"
                        ></el-input> -->
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="得分" prop="score">
                    <template slot-scope="scope">
                      <!-- <el-form-item>
                    <el-input
                      v-model="scope.row.score"
                      :readonly="flag"
                    ></el-input>
                  </el-form-item> -->
                      <span style="line-height: 0; vertical-align: top">
                        {{
                          (scope.row.score =
                            scope.row.totalScore - scope.row.deduct)
                        }}</span
                      >
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="plain"
                    v-if="scope.row.isEdit"
                    @click="saveChange(scope.row)"
                    >保存</el-button
                  >
                  <el-button
                    type="plain"
                    v-else
                    @click="editSingleTable(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column> -->
                </el-table>
              </div>

              <div class="AddSupplierATitle">生产部门综合评分</div>
              <div class="AddSupplierAContent">
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="综合评定等级："
                      prop="productDeptLevel"
                      label-width="140px"
                    >
                      <el-select
                        v-model="ruleForm.productDeptLevel"
                        filterable
                        default-first-option
                        placeholder="请选择"
                        :disabled="flag"
                      >
                        <el-option label="优秀" value="3"></el-option>
                        <el-option label="良好" value="2"></el-option>
                        <el-option label="合格" value="1"></el-option>
                        <el-option label="不合格" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="综合评定意见："
                      label-width="140px"
                      prop="productDeptComment"
                    >
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="ruleForm.productDeptComment"
                        maxlength="200"
                        size="medium"
                        show-word-limit
                        :disabled="flag"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="AddSupplierATitle" v-if="flag">主管部门综合评分</div>
              <div class="AddSupplierAContent" v-if="flag">
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="综合评定意见："
                      prop="dutyDeptComment"
                      label-width="140px"
                    >
                      <el-select
                        v-model="ruleForm.dutyDeptComment"
                        filterable
                        default-first-option
                        placeholder="请选择"
                        disabled
                      >
                        <el-option label="同意" value="1"></el-option>
                        <el-option label="不同意" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="描述："
                      label-width="140px"
                      prop="dutyDeptCommentDesc"
                    >
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="ruleForm.dutyDeptCommentDesc"
                        maxlength="200"
                        size="medium"
                        show-word-limit
                        :disabled="flag"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
            <div class="bottomBtn">
              <el-button
                type="primary"
                @click="submitBtn('ruleForm')"
                v-if="!flag"
                >保 存</el-button
              >
              <el-button type="info" @click="isDialogShow = false" v-if="!flag"
                >取 消</el-button
              >
              <el-button type="info" @click="isDialogShow = false" v-if="flag"
                >关 闭</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="打印设置"
          name="second"
          class="firstTab"
          v-if="flag"
        >
          <!-- 设置打印 -->
          <set-print-data
            :id="ruleForm.id"
            :dataForm="printData"
            @close="isDialogShow = false"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSupplierADetailService, //查询一条甲方供应商
  getSupplierEvaluateDetailService, //查询供应商评分详情
  savePSupplierEvaluateInfo, //查询供应商评分详情
  saveSupplierAInfo, //保存供应商接口
} from "@/services/supplierMagServices";
import setPrintData from "./setPrintData"; //设置打印数据

export default {
  name: "AddSupplierA",
  components: {
    setPrintData,
  },
  data() {
    return {
      activeName: "first",
      isDialogShow: false, //弹窗是否可见
      editFlag: true,
      RouteParam: {}, //存储路由跳转参数
      supplierId: 0, //总包合同ID
      dialogVisible: false, //预览图片是否异步
      dialogImageUrl: "", //预览图片的路径
      workPhone: "",
      legalPerson: "",
      flag: false, //true为详情 false为编辑
      printData: {},
      yearList: [],
      searchForm: {
        contractId: null,
        projectId: null,
        scoreYear: new Date().getFullYear(),
        supplierId: null,
      },
      ruleForm: {
        id: null, //id
        supplierId: null, //supplierId
        supplierName: "", //supplierName
        scoreYear: new Date().getFullYear(),
        contractId: null, //contractId
        contractCode: "", //contractCode
        contractName: "", //contractName
        projectDeptId: null, //projectDeptId
        projectDeptName: "", //projectDeptName
        projectId: null, //projectId
        projectName: "", //projectName
        score: null, //score
        registeredCapital: "", //registeredCapital
        qualificationLevel: "", //qualificationLevel
        productDeptLevel: "", //productDeptLevel
        productDeptLevelDisplayName: "", //productDeptLevelDisplayName
        productDeptComment: "", //productDeptComment
        dutyDeptComment: "", //dutyDeptComment
        dutyDeptCommentDesc: "",
        itemList: [],
        scoreTemplate: "劳务合作单位评价表", //评价模板
      },
      tableData: [],
      tableData1: [
        //劳务合作单位评价表
        {
          indexNum: 1,
          project: "基本情况",
          content:
            "1、有关证照：资质证书、安全生产许可证、现场负责人配备及企业人员三证是否齐全等是否齐全，若不符合扣 5 分\n2、技术人员数量是否满足施工要求，若不符合扣 5 分\n3、操作人员上岗证及操作证是否齐全并人证相符，若不符合扣 5 分",
          totalScore: 15,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 2,
          project: "资源配置",
          content:
            "1、现场管理人员、作业人员的配置和结构：作业人员的年龄结构是否符合要求，若不符合要求的扣 5 分\n2、现场安全管理人员持证上岗，若不符合要求扣 5 分\n3、自带设备是否符合规范，操作人员是否持证上岗：若不符合要求扣 5 分",
          totalScore: 15,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 3,
          project: "工程进度",
          content:
            "1、现场劳务人员配备是否满足进度要求，若不满足扣 5 分\n2、节点工期是否能够完成，若不符合扣 5 分\n3、是否能够按生产部门计划实施，若不符合扣 5 分",
          totalScore: 15,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 4,
          project: "施工安全",
          content:
            "1、是否进行班前安全教育并留存记录，是否建立施工现场安全档案，每缺少一项扣 1 分，共 5 分\n2、是否能够执行安全技术交底，若不符合扣 5 分\n3、安全防护措施是否到位，现场临时用电是否符合要求， 若不符合每处扣 1 分，共 5 分\n4、安全检查及整改是否及时到位，若不符合扣 1 分，共 5 分",
          totalScore: 20,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 5,
          project: "施工质量",
          content:
            "1、自供材料是否符合标准，若不符合每次扣 1 分，共 3 分\n2、是否执行质量管理办法，若不符合扣 3 分\n3、施工质量是否达到一次性验收合格，每次扣 1 分，共 4 分\n4、质量整改是否及时到位，若不符合扣 2 分\n5、若有主管部门下发质量处罚，每次扣 1 分，共 3 分",
          totalScore: 15,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 6,
          project: "现场文明施工",
          content:
            "1、场地布置：现场标牌及场容场貌是否保存规范，若不符\n合，每处扣 3 分\n2、机械设备、材料堆放是否符合要求，若不符合扣 3 分\n3、驻地环境：宿舍、厕所、厨房、住地院内及水电设置是否符合要求，若不符合扣 4 分",
          totalScore: 10,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 7,
          project: "综合管理",
          content:
            "1、合同签订是否及时有效，若不符合要求，扣 4 分\n2、资金能力：是否存在人员上访现象，若有扣 4 分\n3、结算情况：是否积极配合生产部门进行月及总的结算情况，若有不配合扣 2 分。",
          totalScore: 10,
          reason: "",
          deduct: 0,
          score: null,
        },
      ],
      tableData2: [
        //设备物资合作单位评价表
        {
          indexNum: 1,
          project: "基本情况",
          content:
            "1、有关证照：资质证书等是否齐全，若不符合要求扣 5 分\n2、技术人员数量是否满足施工要求，若不符合扣 5 分\n3、操作人员上岗证及操作证是否齐全并人证相符，若不符合扣 5分",
          totalScore: 15,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 2,
          project: "资源配置",
          content:
            "1、现场管理人员、作业人员的配置和结构：若不符合要求的扣 5 分\n2、自带设备是否符合规范，若不符合要求扣 5 分",
          totalScore: 10,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 3,
          project: "供应进度",
          content:
            "1、节点要求是否能够完成，若不符合扣 10分\n2、是否能够按计划实施，若不符合扣 10 分",
          totalScore: 20,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 4,
          project: "施工安全",
          content:
            "1、是否进行班前安全教育并留存记录，是否建立施工现场安全档案，每缺少一项扣 1 分，共 2 分\n2、是否能够执行安全技术交底，若不符合扣 2 分\n3、安全防护措施是否到位，现场临时用电是否符合要求， 若不符合每处扣 1 分，共3 分\n4、安全检查及整改是否及时到位，若不符合扣 1 分，共 3 分",
          totalScore: 10,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 5,
          project: "施工质量",
          content:
            "1、供应材料是否符合标准，若不符合每次扣1分，共 4 分\n2、是否执行质量管理办法，若不符合扣 1 分，共4分\n3、质量是否达到一次性验收合格，每次扣 2分，共4分\n4、质量整改是否及时到位，若不符合扣 1 分，共4分\n5、若有生产部门下发质量处罚，每次扣2分，共4分",
          totalScore: 20,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 6,
          project: "现场文明施工",
          content:
            "1、场地布置：现场标牌及场容场貌是否保存规范，若不符合，每处扣5分\n2、机械设备停放、材料堆放是否符合要求，若不符合扣 5 分",
          totalScore: 10,
          reason: "",
          deduct: 0,
          score: null,
        },
        {
          indexNum: 7,
          project: "综合管理",
          content:
            "1、合同签订是否及时有效，若不符合要求，扣 4 分\n2、资金能力：是否存在人员上访现象，若有扣4 分\n3、现场资料（如：物资台账、机械设备台账、维修保养记   录等等）是否齐全，若不符合要求，扣 4 分\n4、结算情况：是否积极配合生产部门进行月及总的结算情况，若有不配合扣 3 分。",
          totalScore: 15,
          reason: "",
          deduct: 0,
          score: null,
        },
      ],

      rules: {
        scoreYear: [
          { required: true, message: "请选择评定年份", trigger: "blur" },
        ],
        productDeptLevel: [
          { required: true, message: "请选择综合评定等级", trigger: "blur" },
        ],
        // registeredCapital: [
        // {
        //     pattern: /^[0-9,.]+$/,
        //     message: "只能输入数字",
        //   },
        //   // { required: true, message: "只能输入数字", trigger: "blur" },
        // ],
        productDeptComment: [
          { required: true, message: "请输入综合评定意见", trigger: "blur" },
        ],
        dutyDeptComment: [
          {
            required: true,
            message: "请输入主管综合评定意见",
            trigger: "blur",
          },
        ],
        deduct: [{ required: true, message: "请输入扣分", trigger: "blur" }],
        score: [{ required: true, message: "请输入评分", trigger: "blur" }],
        reason: [
          { required: true, message: "请输入扣分原因", trigger: "blur" },
        ],
      },
      isShopNameBool: false,
    };
  },
  mounted() {
    this.getYears();
  },
  methods: {
    //获取路由跳转传参
    // onActive() {
    //   this.editFlag = this.tabRouteParam ? this.tabRouteParam.editFlag : false;
    //   this.RouteParam = this.tabRouteParam;
    //   if (this.editFlag) {
    //     //编辑 获取一条供应商信息
    //     this.ruleForm.id = this.tabRouteParam.id;
    //     this.getSupplierEvaluateDetail(this.ruleForm.id);
    //   } else {
    //     this.tableData = this.tableData1;
    //     this.ruleForm.topType = this.tabRouteParam
    //       ? this.tabRouteParam.topType
    //       : "aType";
    //   }
    // },
    //获取一条生产部门评价信息
    getSupplierEvaluateDetail() {
      // param.supplierScoreId = id;
      getSupplierEvaluateDetailService(this.searchForm)
        .then((res) => {
          if (res.code == 10000000 && res.data.score) {
            this.ruleForm = {
              ...res.data,
              supplierName: this.ruleForm.supplierName,
              registeredCapital:
                res.data.registeredCapital || this.ruleForm.registeredCapital, //registeredCapital
              qualificationLevel:
                res.data.qualificationLevel || this.ruleForm.qualificationLevel,
            };
            this.ruleForm.scoreTemplate =
              this.ruleForm?.scoreTemplate ?? "劳务合作单位评价表";
            this.tableData =
              this.ruleForm.scoreTemplate == "劳务合作单位评价表"
                ? this.tableData1
                : this.tableData2;
            this.ruleForm.productDeptLevel =
              null != this.ruleForm.productDeptLevel
                ? this.ruleForm.productDeptLevel.toString()
                : "";
            let arr = res.data.itemList || [];
            if (arr.length > 0) {
              for (let i = 0; i < this.tableData.length; i++) {
                // let index = arr[i].indexNum - 1;
                this.tableData[i].indexNum = arr[i]?.indexNum ?? i + 1;
                this.tableData[i].score =
                  arr[i]?.score ?? this.tableData[i].score;
                this.tableData[i].deduct = arr[i]?.deduct ?? 0;
                this.tableData[i].reason = arr[i]?.reason ?? "";
              }
            }
            this.ruleForm.scoreYear
              ? this.ruleForm.scoreYear
              : new Date().getFullYear();
            if (this.flag) {
              this.ruleForm.dutyDeptComment =this.ruleForm.dutyDeptComment!=null?this.ruleForm.dutyDeptComment.toString():null
              this.printData = { ...this.ruleForm };
              this.printData.legalPerson = this.legalPerson;
              this.printData.tableData = this.tableData;
            }
            if (!this.flag) {
              this.$confirm(
                "该合作单位本年度已经完成评价。是否重新评定？",
                "提示",
                {
                  confirmButtonText: "继续评价",
                  cancelButtonText: "关闭",
                  type: "warning",
                }
              )
                .then(() => {
                  // 用户确认: 更改选项并关闭下拉菜单
                  this.$refs.elSelect.blur();
                })
                .catch(() => {
                  // 用户取消: 重置选项并关闭下拉菜单
                  this.$refs.elSelect.blur();
                  this.isDialogShow = false;
                });
            }
          } else if (res.code == 60010013 || !res.data.score) {
            this.ruleForm = {
              supplierId: this.searchForm.supplierId, //supplierId
              supplierName: this.ruleForm.supplierName, //supplierName
              scoreYear: this.searchForm.scoreYear,
              contractId: this.searchForm.contractId, //contractId
              contractCode: "", //contractCode
              contractName: "", //contractName
              projectDeptId: "", //projectDeptId
              projectDeptName: "", //projectDeptName
              projectId: this.searchForm.projectId, //projectId
              projectName: "", //projectName
              score: null, //score
              registeredCapital: this.ruleForm.registeredCapital, //registeredCapital
              qualificationLevel: this.ruleForm.qualificationLevel, //qualificationLevel
              productDeptLevel: "", //productDeptLevel
              productDeptLevelDisplayName: "", //productDeptLevelDisplayName
              productDeptComment: "", //productDeptComment
              dutyDeptComment: "", //dutyDeptComment
              itemList: [],
              scoreTemplate: "劳务合作单位评价表", //评价模板
            };
            this.tableData = this.tableData1;
            this.tableData.forEach((item) => {
              item.score = null;
              item.deduct = 0;
              item.reason = "";
              return item;
            });
            // this.workPhone = "";
            // this.legalPerson = "";
          } else if (res.code >= 20000000) {
            this.$message(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    changeValue() {
      this.tableData =
        this.ruleForm.scoreTemplate == "劳务合作单位评价表"
          ? this.tableData1
          : this.tableData2;
    },
    changeYear(value) {
      this.searchForm.scoreYear = value;
      this.getSupplierEvaluateDetail();
    },

    //获取一条供应商信息
    getSupplierDetail(supplierId) {
      let param = {};
      param.supplierId = supplierId;
      getSupplierADetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.ruleForm.supplierName = res.data.companyName;
            this.workPhone = res.data.workPhone;
            this.legalPerson = res.data.legalPerson;
            this.printData.legalPerson = this.legalPerson;
            this.printData.supplierName = this.ruleForm.supplierName;

            // this.ruleForm.legalPerson = res.data.legalPerson;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    showDialog(row, flag) {
      this.searchForm.contractId = row.contractId;
      this.searchForm.projectId = row.projectId;
      this.searchForm.scoreYear = row.scoreYear || new Date().getFullYear();
      this.searchForm.supplierId = row.supplierId;
      // this.ruleForm.id = row.id;
      this.activeName = "first";
      this.isDialogShow = true;
      this.flag = flag;
      if(row.isFinished&&row.finishedTime){
        row.finishedTime=new Date(row.finishedTime) 
        this.getYears(7,row.finishedTime)        
      }else{
        this.getYears(7,new Date())
      }
      this.ruleForm = {
        id: null, //id
        supplierId: this.searchForm.supplierId, //supplierId
        supplierName: row.supplierName, //supplierName
        scoreYear: this.searchForm.scoreYear,
        contractId: this.searchForm.contractId, //contractId
        contractCode: "", //contractCode
        contractName: "", //contractName
        projectDeptId: null, //projectDeptId
        projectDeptName: "", //projectDeptName
        projectId: this.searchForm.projectId, //projectId
        projectName: "", //projectName
        score: null, //score
        registeredCapital: "", //registeredCapital
        qualificationLevel: "", //qualificationLevel
        productDeptLevel: "", //productDeptLevel
        productDeptLevelDisplayName: "", //productDeptLevelDisplayName
        productDeptComment: "", //productDeptComment
        dutyDeptComment: "", //dutyDeptComment
        itemList: [],
        scoreTemplate: "劳务合作单位评价表", //评价模板
      };
      this.tableData1.forEach((item) => {
        item.score = null;
        item.deduct = 0;
        item.reason = "";
        return item;
      });
      this.tableData2.forEach((item) => {
        item.score = null;
        item.deduct = 0;
        item.reason = "";
        return item;
      });
      this.tableData = this.tableData1;
      if (row.score) this.getSupplierEvaluateDetail();
      this.getSupplierDetail(this.searchForm.supplierId);
    },

    //提交
    submitBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editFlag) {
            //更新
            let arr = this.tableData;
            this.ruleForm.score = 72;
            this.ruleForm.itemList.length = 0;
            if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                let index = arr[i].indexNum - 1;
                let param = {};
                param.score = arr[index].score;
                param.deduct = arr[index].deduct;
                param.indexNum = arr[index].indexNum;
                param.reason = arr[index].reason;
                param.totalScore = arr[index].totalScore;
                this.ruleForm.itemList.push(param);
              }
              // this.ruleForm.itemList=items;
            }
            savePSupplierEvaluateInfo(this.ruleForm).then((res) => {
              if (res.code == 10000000) {
                this.$refs.ruleForm.clearValidate();
                this.isDialogShow = false;
                this.$emit("close");
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            saveSupplierAInfo(this.ruleForm).then((res) => {
              if (res.code == 10000000) {
                this.$refs.ruleForm.clearValidate();
                this.$refs["ruleForm"].clearValidate();
                this.bus.$emit("tabClose", "addSupplierAPage");
                this.bus.$emit("navMenuChange", {
                  routeId: "supplierAListPage",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    closeDialog() {
      this.$emit("close");
    },
    //设置小计
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 4) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          column.property == "score"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += '';
          // sums[index] = numFilter(sums[index]);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    //跳转查看公司详情
    openCompanyDetail() {
      if (this.ruleForm.supplierId) {
        this.isDialogShow = false;
        let memberData = {};
        memberData.detailFlag = "B"; //详请 false 审核 true
        memberData.id = this.ruleForm.supplierId; //公司主键
        this.bus.$emit("navMenuChange", {
          routeId: "supplierDetail",
          routeParam: memberData,
        });
      }
    },
    //获取年份
    getYears(num = 7,currentDate=new Date()) {
      // 存储年份数据的数组
      let list = [];
      // // 获取前一年的数据
      // const prevYear = {
      //   name: Number(`${currentYear - 1}`),
      //   label: `${currentYear - 1}年`
      // };
      // list.push(prevYear);
      // 获取当前年份
      const currentYear = currentDate?.getFullYear()??currentDate;
      list.push({
        name: Number(`${currentYear}`),
        label: `${currentYear}年`,
      });
      // 获取后面几年的数据
      for (let i = 1; i <= num; i++) {
        const nextYear = {
          name: Number(`${currentYear - i}`),
          label: `${currentYear - i}年`,
        };
        list.push(nextYear);
      }
      this.yearList=[]
      this.yearList = list;
    },
  },
};
</script>

<style scoped lang="scss">
.enterpriseAndCommonality {
  background-color: white;
  .contactsForm {
    height: 660px;
    overflow: auto;
  }

  // height: 100%;
}
/deep/.el-icon-close:before {
  color: #fff;
}
/deep/.el-table .cell {
  white-space: pre-line;
  line-height: 20px;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}
/deep/.el-dialog {
  margin-top: 4vh !important;
}

/deep/.el-popover {
  padding: 24px;
}
.AddSupplierA {
  width: 100%;
}
@media only screen and(max-width:1680px) {
  .AddSupplierA {
    width: 100%;
  }
}
.AddSupplierA {
  background: rgba(255, 255, 255, 1);
  .el-form-item {
    width: 100%;
  }
  /deep/.cell .el-form-item__content {
    margin-left: 1px !important;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);
    line-height: 20px;

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
 /deep/ .el-input-number--mini {
    width: 100px;
}
  .bottomBtn {
    border-top: 1px solid #e6e6e6;
    width: 90%;
    height: 44px;
    line-height: 50px;
    text-align: center;
    margin-bottom: 0px;
  }
  .AddSupplierATitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .AddSupplierAContent {
    padding: 14px 8px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }
}
</style>
